module.exports = __webpack_public_path__ + "img/earphones.d93f724d.svg";